// public/js/modules/ui/colorData.js


export const COLOR_TARGET_MAP = {
    main: {
        name: "Main Color",
        property: "--color-frame",
        additionalProperties: [
            "--color-music-player-bg"
        ]
    },
    highlight2: {
        name: "Highlight 2",
        property: "--color-active-highlight",
        additionalProperties: [
            "--color-accent-highlight-2",
            "--color-queue-bg"
        ]
    },
    tertiary: {
        name: "Tertiary",
        property: "--color-console-main",
        additionalProperties: [
            "--color-playbar-accent-bg",
            "--color-windows-inner-bg",
            "--color-tertiary",
            "--color-player-bg"
        ]
    },
    highlight1: {
        name: "Highlight 1",
        property: "--color-top-windows-bg",
        additionalProperties: [
            "--color-button-default-bg",
            "--color-icon-default",
            "--color-accent-highlight-1",
            "--color-emoji-bar-bg"
        ]
    },
    secondary: {
        name: "Secondary",
        property: "--color-windows-bg",
        additionalProperties: [
            "--color-chat-bubble-user-bg",
            "--color-channel-content-bg",
            "--color-queue-banner-bg",
            "--color-waveform-bg",
            "--color-carousel-bg"
        ]
    }
};


export const LEGACY_COLOR_KEY_MAP = {
    highlights2: 'highlight2'
};


export function getColorGroupOrder() {
    return [
        'main',
        'highlight2',
        'tertiary',
        'highlight1',
        'secondary'
    ];
}


export const GOOGLE_FONTS = [
    'Roboto',
    'Open Sans',
    'Lato',
    'Montserrat',
    'Oswald',
    'Raleway',
    'Poppins',
    'Inter'
];